const UiStepsInputPropsOption = {
  placeholder: { type: Object },
  widthNumber: { type: Number, default: 76 },
  modelValue: { type: Object, required: true },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  spacing: { type: Number, default: 14 },
  width: { type: Number, default: 408 },
  size: { type: String, default: "default" },
  name: { type: String }
};
const UiStepsInputEmits = {
  change: (_ev) => true,
  input: (_ev) => true,
  focus: (_ev) => true,
  blur: (_ev) => true
};

export { UiStepsInputEmits, UiStepsInputPropsOption };
//# sourceMappingURL=index.mjs.map
